import React from 'react';
import ReactDOM from 'react-dom/client';
// Removed './index.css' if not needed, App.css is imported in App.js
import App from './App';
import reportWebVitals from './reportWebVitals';

// Import Bootstrap JS bundle (includes Popper) if needed for components like Dropdowns, Modals etc.
// Make sure it's imported *after* React renders the components that might use it.
// Often better to use react-bootstrap components which handle JS internally.
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);